<template>
  <vue-scroll :ops="ops">
    <v-card elevation="0">
      <v-toolbar elevation="0" color="transparent">
        <span class="headline font-weight-regular">{{
          this.$Amplify.I18n.get("Filters and Queries")
        }}</span>
        <v-spacer></v-spacer>
        <v-fab-transition>
          <v-btn
            fab
            x-small
            dark
            v-show="drawer"
            @click="openSidebar"
            color="error"
          >
            <v-icon normal>mdi-close</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-toolbar>
      <v-card-text class="pt-0">
        <seleccionar-empresa></seleccionar-empresa>

        <v-tabs grow v-model="tab">
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-1" class="pa-0 ma-0">
            <v-badge
              class="pa-0 ma-0"
              inline
              :content="filters.length"
              :value="filters.length"
              color="primary"
              transition="scale-transition"
            >
              {{ this.$Amplify.I18n.get("Filters") }}
            </v-badge>
          </v-tab>
          <v-tab href="#tab-2" class="pa-0 ma-0">
            <v-badge
              class="pa-0 ma-0"
              inline
              :content="queries.length"
              :value="queries.length"
              color="primary"
              transition="scale-transition"
            >
              {{ this.$Amplify.I18n.get("Saved Queries") }}
            </v-badge>
          </v-tab>

          <v-tab href="#tab-3" class="pa-0 ma-0">
            <v-badge
              class="pa-0 ma-0"
              inline
              :content="misCpcs.length"
              :value="misCpcs.length"
              color="primary"
              transition="scale-transition"
            >
              {{ this.$Amplify.I18n.get("Mis CPC´s") }}
            </v-badge>
          </v-tab>

          <v-tab-item value="tab-1">
            <filter-list></filter-list>
          </v-tab-item>

          <v-tab-item value="tab-2">
            <consultas-almacenadas></consultas-almacenadas>
          </v-tab-item>

          <v-tab-item value="tab-3">
            <mis-cpcs></mis-cpcs>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </vue-scroll>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapGetters, mapActions } from "vuex";
import SeleccionarEmpresa from "@/components/SeleccionarEmpresa";
import FilterList from "@/components/FilterList";
import ConsultasAlmacenadas from "@/components/ConsultasAlmacenadas";
import MisCpcs from "@/components/MisCpcs";

import { unzipHeadersAndRows } from "@/services/elastic/response/jsonUtils";
import { getConsultas } from "@/api/private/consultas";

export default {
  name: "DashboardLayoutLeft",
  components: {
    SeleccionarEmpresa,
    FilterList,
    ConsultasAlmacenadas,
    MisCpcs,
  },
  data() {
    return {
      tab: null,
      ops: {
        bar: {
          background: "#cdcae0",
          keepShow: true,
          size: "12px",
          minSize: "0.1",
        },
      },
    };
  },
  methods: {
    ...mapActions(["setQueriesAction", "toggleDashBoardDrawer"]),
    openSidebar() {
      this.toggleDashBoardDrawer();
    },
    loadData: async function() {
      try {
        console.log("cargando consultas");
        const { consultas } = await getConsultas();
        let queries = unzipHeadersAndRows(consultas);
        this.setQueriesAction(queries);
      } catch (e) {
        console.log(e);
      } finally {
        AmplifyEventBus.$emit("end-load-saved-queries");
      }
    },
  },
  computed: {
    ...mapGetters(["filters", "queries", "misCpcs"]),
    drawer() {
      return this.$store.getters.dashboardDrawer;
    },
  },
  async mounted() {
    await this.loadData();
  },
  beforeCreate: function() {
    AmplifyEventBus.$on("load-saved-queries", () => {
      this.loadData();
    });
    AmplifyEventBus.$on("set-tab-dashboard-layout-left", (tab) => {
      this.tab = tab;
    });
  },
  beforeDestroy: function() {
    AmplifyEventBus.$off("load-saved-queries");
    AmplifyEventBus.$off("set-tab-dashboard-layout-left");
  },
};
</script>
